export * from './deviation-type.component';
